<template>
    <ModalComponent
        name="cargarButacasEventoAnterior"
        title="Cargar butacas bloqueadas de evento anterior"
        @opened="getEvents"
        v-on:close="() => close(false)">

        <h4 class="alert alert-danger col-12 text-center">Si carga las butacas se borrará los bloqueos actuales de este evento</h4>

        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit" v-if="events">
            <div>
                <label for="old_event">Evento</label>
                <multiselect
                    id="old_event"
                    v-model="old_event"
                    placeholder="Seleccionar evento"
                    label="name"
                    track-by="id"
                    :options="events"
                    :multiple="false"
                    :max-height="130"
                />
            </div>
            <div class="mt-3" v-if="old_event?.sesiones">
                <label for="old_sesion">Sesión</label>
                <multiselect
                    id="old_sesion"
                    v-model="old_sesion"
                    placeholder="Seleccionar sesión"
                    track-by="id"
                    :custom-label="customLabel"
                    :options="old_event.sesiones"
                    :multiple="false"
                    :max-height="130"
                ></multiselect>
            </div>
            <Button class="mt-4" :disabled="!old_event || !old_sesion" @click="cargar">Cargar</Button>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>

import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['evento'],
    data() {
        return {
            events: [],
            old_event: null,
            old_sesion: null
        }
    },
    methods: {
        close() {
            this.old_event = null;
            this.$emit('close', 'cargarButacasEventoAnterior');
        },
        getEvents : function() {
            const data = {
                filters: {
                    per_page: 100,
                    page: 1,
                    search: '',
                    to_select: true
                }
            };
            this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                this.events = res.data.filter(event => event.place_id === this.evento?.place_id && event.id != this.$route.params.evento_id && event.sesiones?.length > 0);
            });
        },
        customLabel(sesion) {
            var texto = sesion.session_date;

            if (sesion.text) {
                texto += (' - ' + sesion.text)
            }

            return texto; 
        },
        cargar(){
            this.$emit('cerrarbutacas', this.old_event, this.old_sesion);
            this.close();
        }
    },
    components: {
        ModalComponent
    }
}
</script>
